module.exports = __webpack_public_path__ + "static/media/raya.28810d57.png";